import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi) // Carga archivos JSON de traducciones
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    lng: 'es',
    // debug: process.env.NODE_ENV === 'development',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Ruta de los archivos JSON
    },
    ns: ['translation', 'PRIVACY_POLICY', 'M_R_P_C', 'M_R_M_C'], // Puedes dejar un namespace por defecto
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    react: {
      // transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'b', 'href', 'a'],
      useSuspense: false, // Desactiva Suspense para evitar el error
    },
  });

export default i18n;
